module.exports = __webpack_public_path__ + "static/media/icon_all.f65e8552.png";